<template>
  <azcon-training-card-skeleton v-if="loading"/>

  <div v-else class="azcon-training-card">
    <a
      href="javascript:void(0)"
      @click.prevent="openTraining(training)"
    >
      <div class="azcon-training-card__image" :style="trainingImageStyle"></div>
      <p class="azcon-training-card__title">{{ training.name || training.title }}</p>
    </a>
  </div>
</template>

<script>
import AzconTrainingCardSkeleton from "./AzconTrainingCardSkeleton.vue";

export default {
  name: "AzconTrainingCard",
  components: { AzconTrainingCardSkeleton },
  props: {
    training: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    route: {
      type: Object,
      default: null,
    },
  },
  computed: {
    trainingImageStyle() {
      const url = this.training.cover_image_link || this.training.photo_link || this.training.image || this.training.cover_image;
      if (!url) return {};
      return {
        backgroundImage: `url(${url})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#ffffff",
      };
    },
  },
  methods: {
    openTraining() {
      this.$router.push(this.route || {
        name: "user.education-category",
        query: { tab: "can_register_trainings", tabId: "0" },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.azcon-training-card {
  a {
    display: block;
    margin: 0;
    text-decoration: none;
    color: inherit;
  }

  &__image {
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 10px;
    border: 1px solid #cbd5e1;
    box-shadow: 0 2px 6px rgba(10, 20, 35, 0.05);
    background-color: #ffffff;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__title {
    margin: 6px 0 0;
    font-size: 12px;
    font-weight: 600;
    color: #4a5c71;
  }
}
</style>
